"use strict";Object.defineProperty(exports, "__esModule", {value: true});

// Writes `text` over the selection and returns the new value and caret.
 const insertText = (value, selectionStart, selectionEnd, text) => {
  const start = Math.min(Math.max(0, selectionStart), value.length)
  const end = Math.min(Math.max(start, selectionEnd), value.length)
  return { value: value.slice(0, start) + text + value.slice(end), caret: start + text.length }
}; exports.insertText = insertText

// What a platform composer exposes to the modules that plug into it.







